import type { QueryKey } from '@tanstack/react-query';

import { getQueryClient } from '../queryClientSingleton';

export interface State<Data> {
    isPending: boolean;
    didInvalidate: boolean;
    error?: any;
    data?: Data;
    lastUpdated: null | number;
}

export function getFlatPagesOrEmpty<Entity>(data?: { pages: { data: Entity[] }[] }): Entity[] {
    return data?.pages?.flatMap((p) => p.data) || [];
}

const identity = (e: any) => e;

export function selectState<Data>(
    name: QueryKey,
    transformData: (e: any) => Data = identity,
): State<Data> {
    const client = getQueryClient();
    const state = client.getQueryState(name);
    return {
        isPending: state?.fetchStatus === 'fetching' || false,
        error: state?.error || undefined,
        didInvalidate: state?.isInvalidated || false,
        data: transformData(state?.data) as Data | undefined,
        lastUpdated: state?.dataUpdatedAt ?? null,
    };
}
